import { ticketTypes } from '../types/ticketTypes';
import { ticketService } from '../../services/ticketService'; 
import { toast } from 'react-toastify';

export const ticketAction = {
    getAll,
    add,
    edit,
    update,
    deleteTicket,
    changeOrder
}

function getAll() {
    return dispatch => {
        dispatch({type:ticketTypes.GETALL_TICKET_REQUEST}); 
        ticketService.getAll().then(res => {
            if (res.status) {
                dispatch({type:ticketTypes.GETALL_TICKET_SUCCESS, data: res.data });
                //toast.success(res.message);
            } else {
                dispatch({type:ticketTypes.GETALL_TICKET_ERROR}); 
                toast.error(res.message);
            }
        })

    }
}
function add(data, setErrors, setSubmitting, navigate){
    return dispatch => {
        dispatch({type:ticketTypes.ADD_TICKET_REQUEST});
        ticketService.add(data).then(res => {
            if(res.status){
               dispatch({type:ticketTypes.ADD_TICKET_SUCCESS, data});
               toast.success(res.message);
               setSubmitting(false);
               navigate(-1);
            }else{
                dispatch({type:ticketTypes.ADD_TICKET_ERROR, error:res.error});
                toast.error(res.message);
                setSubmitting(false);
                if(res.error) {
                    setErrors(res.error);
                }
            }
        })
    }
}

function deleteTicket(code, closeModal){ 
    return dispatch => {
        dispatch({type:ticketTypes.DELETE_TICKET_REQUEST});
        ticketService.deleteTicket(code).then(res => { 
            if(res.status){
                dispatch({type:ticketTypes.DELETE_TICKET_SUCCESS, code});
                toast.success(res.message);
                closeModal();
                setTimeout(function () {
                    dispatch(ticketAction.getAll());
                }, 500);
            }else{
                dispatch({type:ticketTypes.DELETE_TICKET_ERROR, error:res.error});
                toast.error(res.message);
            }
        })
    }
}

function update(code, data, setErrors, setSubmitting, navigate){    
    return dispatch => {
        dispatch({type:ticketTypes.UPDATE_TICKET_REQUEST});
        ticketService.update(code,  data).then(res => {
            if(res.status){
                dispatch({type:ticketTypes.UPDATE_TICKET_SUCCESS, data:res.data});
                toast.success(res.message);
                setSubmitting(false);
                navigate(-1);
            }else{ 
                dispatch({type:ticketTypes.UPDATE_TICKET_ERROR, error:res.error});
                toast.error(res.message);
                setSubmitting(false);
                if(res.error) {
                    setErrors(res.error);
                    setSubmitting(false);
                }
            }
        })
    }
}

function edit(id){
    return dispatch => {
        dispatch({type:ticketTypes.EDIT_TICKET_REQUEST});
        ticketService.edit(id).then(res => {
            if(res.status){
                dispatch({type:ticketTypes.EDIT_TICKET_SUCCESS, data:res.data})
            }else{
                dispatch({type:ticketTypes.EDIT_TICKET_ERROR, error:res.error});
                toast.error(res.message);
            }
        })
    }
}

function changeOrder(id, newRankOrder){
    return dispatch => {
        dispatch({type:ticketTypes.CHANGE_ORDER_TICKET_REQUEST});
        ticketService.changeOrder(id, newRankOrder).then(res => {
            if(res.status){
                dispatch({type:ticketTypes.CHANGE_ORDER_TICKET_SUCCESS});
                toast.success(res.message);
            }else{
                dispatch({type:ticketTypes.CHANGE_ORDER_TICKET_ERROR, error:res.error});
                toast.error(res.message);
            }
        })
    }
}
